export const fetchLabwareList = async () => {
    return fetch(process.env.REACT_APP_ELN_SERVER_URL, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            func: 'listLabwareForUser',
            username: 'gerard',
            params: {},
        }),
    }).then((response) => {
        return response.json();
    }).then((data) => {
        return data.result;
    })
}

export const getObject = async (id) => {
    return fetch(process.env.REACT_APP_SERVER_URL + '/rt/object', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            func: 'getObject',
            username: 'gerard',
            params: {
                object_id: id
            },
        }),
    }).then((response) => {
        return response.json();
    }).then((data) => {
        return data.result;
    })
}